module.exports = __webpack_public_path__ + "img/icon-sit.a0a3b2ce.svg";